import { actions as notificationActions } from '@saucelabs/sl-container-notifications';

import { operations as usersOperations } from './../../ducks/users';
import * as actions from './actions';
import { CTA_EVENTS, trackEvent } from './../../tracking';

export const createUser = (payload) => (dispatch, getState) => {
  const currentUserOrganizationId = getState().user.get('organization').id;

  dispatch(trackEvent(CTA_EVENTS.ADD_USER_MODAL.SUBMIT));
  return dispatch(actions.createUser({
    organizationId: currentUserOrganizationId,
    ...payload,
  }));
};

export const createInvitation = (payload) => (dispatch, getState) => {
  const currentUserOrganizationId = getState().user.get('organization').id;

  dispatch(trackEvent(CTA_EVENTS.ADD_USER_MODAL.SUBMIT_INVITE));
  return dispatch(actions.createInvitation({
    organizationId: currentUserOrganizationId,
    ...payload,
  }));
};

export const clearTeamsOfSelectedUsers = () => (dispatch, getState) => {
  const { selectedUsers } = getState().apps.teamManagement;
  const teamRemovalRequests = selectedUsers
    .reduce((result, user) => [
      ...result,
      ...user.teams.map((team) => (
        dispatch(usersOperations.removeMembership({ user: user.id, team: team.id }))
      )),
    ], []);

  return Promise.all(teamRemovalRequests)
    .catch((error) => {
      dispatch(notificationActions.notifyDanger('Something went wrong with team assignment'));
      throw error;
    });
};
